import React from "react";
import { D } from "../ui";

// Catmull-Rom → bezier untuk garis lengkung mulus ala grafik referensi
function smoothPath(pts) {
  if (pts.length < 2) return "";
  let d = `M ${pts[0][0]},${pts[0][1]}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
    const c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
    const c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
    d += ` C ${c1x.toFixed(1)},${c1y.toFixed(1)} ${c2x.toFixed(1)},${c2y.toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
  }
  return d;
}

// Grafik garis lengkung 3 seri (bangunan / jalan / suka per kota) — kartu "Pertumbuhan Kota"
export function GrowthChart({ cities, totals, card, cardTitle }) {
  const W = 620, H = 240, PAD_L = 46, PAD_B = 18, PAD_T = 14, PAD_R = 96;
  const sorted = [...cities].sort((a, b) => a.city_id.localeCompare(b.city_id));
  const series = [
    { key: "buildings", color: D.blue, label: "Bangunan", total: totals.buildings, pillBg: D.blue, pillInk: "#fff" },
    { key: "roads", color: D.dark, label: "Jalan", total: totals.roads, pillBg: D.dark, pillInk: "#fff" },
    { key: "likes", color: D.gray, label: "Suka", total: totals.likes, pillBg: "#d8d5c6", pillInk: D.ink },
  ];
  const plotW = W - PAD_L - PAD_R, plotH = H - PAD_T - PAD_B;
  const maxAll = Math.max(1, ...series.map(s => Math.max(1, ...sorted.map(c => c[s.key]))));
  const lines = series.map(s => {
    const maxS = Math.max(1, ...sorted.map(c => c[s.key]));
    const pts = sorted.map((c, i) => [
      PAD_L + (i / Math.max(1, sorted.length - 1)) * plotW,
      PAD_T + plotH - (c[s.key] / maxS) * (plotH * 0.86) - plotH * 0.06 * (1 - series.indexOf(s) / 3)
    ]);
    return { ...s, pts, d: smoothPath(pts) };
  });
  const ticks = [maxAll, Math.round(maxAll * 0.66), Math.round(maxAll * 0.4), Math.round(maxAll * 0.16), 0];

  return (
    <div data-testid="chart-card" style={{ ...card, flex: 1.5, minWidth: 420 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <b style={cardTitle}>Pertumbuhan Kota</b>
        <div style={{ display: "flex", gap: 14, fontSize: 11, fontWeight: 700, color: D.sub, marginRight: 40 }}>
          {lines.map(l => (
            <span key={l.key} style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: l.color }} /> {l.label}
            </span>
          ))}
        </div>
      </div>
      <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ marginTop: 10, display: "block" }}>
        {ticks.map((t, i) => {
          const y = PAD_T + plotH - (t / maxAll) * (plotH * 0.86);
          return (
            <g key={i}>
              <line x1={PAD_L} y1={y} x2={W - PAD_R + 30} y2={y} stroke={D.line} strokeWidth="1.4" />
              <text x={PAD_L - 10} y={y + 4} textAnchor="end" fontSize="10.5" fontWeight="600" fill={D.sub}>{t}</text>
            </g>
          );
        })}
        {lines.map((l, li) => (
          <g key={l.key}>
            <path d={l.d} fill="none" stroke={l.color} strokeWidth="2.6" strokeLinecap="round" />
            {(() => {
              const [ex, ey] = l.pts[l.pts.length - 1];
              const py = Math.max(PAD_T + 13, Math.min(ey + (li - 1) * 30, PAD_T + plotH - 13));
              return (
                <g>
                  <line x1={ex} y1={ey} x2={ex + 8} y2={py} stroke={l.color} strokeWidth="1.2" strokeDasharray="2 3" />
                  <rect x={ex + 8} y={py - 13} rx={13} width={82} height={26} fill={l.pillBg} />
                  <text x={ex + 49} y={py + 4} textAnchor="middle" fontSize="11.5" fontWeight="800" fill={l.pillInk}>{l.total} {l.label}</text>
                </g>
              );
            })()}
          </g>
        ))}
      </svg>
    </div>
  );
}
